import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/dist/styles.css';
import store from './store/index';
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from "react-router-dom";


ReactDOM.render(
  <Router>
    <Provider store={store}>
      <AppProvider i18n={enTranslations}>
        {/* <React.StrictMode> */}
          <App />
        {/* </React.StrictMode> */}
      </AppProvider >
    </Provider >
  </Router >
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
